import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';

import { PartnerBadge } from 'src/components/atoms/PartnerBadge/PartnerBadge';
import { PartnerDetails } from 'src/components/molecules/PartnerMiniModule/components/PartnerDetails/PartnerDetails';
import { PartnerInfo } from 'src/components/molecules/PartnerMiniModule/components/PartnerInfo/PartnerInfo';
import { PartnerMiniModuleSkeleton } from 'src/components/molecules/PartnerMiniModule/components/PartnerMiniModuleSkeleton/PartnerMiniModuleSkeleton';
import * as styles from './PartnerMiniModule.styles';

interface PartnerMiniModuleProps {
  dateJoined?: string;
  /** When true, a loading skeleton is shown until the partner data is ready. */
  isLoading?: boolean;
  isTopBrand?: boolean;
  linkHref: string;
  location: string;
  logoSrc: string;
  name: string;
  numberOfOrders?: number;
  onLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onVisible?: () => void;
  rating?: number;
}

export const PartnerMiniModule = ({
  dateJoined,
  isLoading = false,
  isTopBrand = false,
  linkHref,
  location,
  logoSrc,
  name,
  numberOfOrders,
  onLinkClick,
  onVisible,
  rating,
}: PartnerMiniModuleProps) => {
  const rootRef = useImpressionRef<HTMLDivElement>(() => onVisible?.());

  return (
    <div css={styles.root} ref={rootRef}>
      {isLoading ? (
        <PartnerMiniModuleSkeleton />
      ) : (
        <>
          {isTopBrand && (
            <div css={styles.topBrandHeader}>
              <PartnerBadge />
            </div>
          )}
          <div css={styles.content}>
            <PartnerDetails
              linkHref={linkHref}
              location={location}
              logoSrc={logoSrc}
              name={name}
              onLinkClick={onLinkClick}
            />
            <PartnerInfo dateJoined={dateJoined} numberOfOrders={numberOfOrders} rating={rating} />
          </div>
        </>
      )}
    </div>
  );
};
